import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminService } from '../../../admin/admin.service';
import {
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
  debounceTime,
} from 'rxjs/operators';
import { ReportingService } from '../../reporting.service';
import { DateTime } from 'luxon';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-sales-tracking',
  templateUrl: './sales-tracking.component.html',
  styleUrls: ['./sales-tracking.component.scss'],
  imports: [
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    GridModule,
    MatIconModule,
    ExcelModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
  ],
  providers: [],
})
export class SalesTrackingComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private rptSvc = inject(ReportingService);

  unitsControl = new FormControl();

  selectedUnit;
  sales = {
    unit: null,
    user: null,
    at: 'ALL',
    st: 'ALL',
    ri: 'ALL',
    gap: 720,
    startDate: null,
    endDate: null,
  };
  filteredUnits;
  activityTypes = ['ALL', 'BA', 'LK'];
  saleTypes = ['ALL', 'LI', 'IN', 'OP', 'AN', 'IV'];
  repIntersectTypes = ['ALL', 'True', 'False'];
  salesTrackingData;

  ngOnInit(): void {
    this.salesTrackingData = { data: null, headers: null };
    this.getUnits();
  }

  getSalesTracking() {
    this.rptSvc.getSalesTracking(this.sales).subscribe({
      next: data => {
        this.salesTrackingData = { ...data.results };
      },
      error: error => {
        console.error(error);
      },
    });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  changeDate(ev) {
    if (ev.targetElement.className.includes('start-date')) {
      this.sales.startDate = DateTime.fromJSDate(new Date(ev.value))
        .startOf('day')
        .toUTC()
        .toISO();
    } else if (ev.targetElement.className.includes('end-date')) {
      this.sales.endDate = DateTime.fromJSDate(new Date(ev.value))
        .endOf('day')
        .toUTC()
        .toISO();
    }
  }
}
